import { SortDirection } from 'components/Table/types';
import { useInfiniteQuery } from 'react-query';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { getOrders } from 'services/OrdersService';
import { AppMode } from 'store/Common/reducers/common';
import { getNextPageParam } from 'utils/getNextPageParam';
import {
  hasSendingOrder,
  LIST_POLL_INTERVAL_MS,
} from 'pages/SupplierOrdersPage/hooks';

// The single order, its status change and its Retry are shared with the
// supplier's pages: pages/SupplierOrdersPage/hooks.
export const useGetBuyerOrdersInfinite = (
  appMode: AppMode,
  companyId: number,
  perPage: number,
  searchBy?: string,
  sortBy?: string,
  sortDirection?: SortDirection
) =>
  useInfiniteQuery({
    queryKey: [
      ReactQueryKeys.GET_BUYER_ORDERS,
      companyId,
      perPage,
      searchBy,
      sortBy,
      sortDirection,
    ],
    queryFn: ({ pageParam = 1 }) => {
      return getOrders(
        appMode,
        companyId,
        pageParam,
        perPage,
        searchBy,
        sortBy,
        sortDirection
      );
    },
    getNextPageParam,
    refetchInterval: (data) =>
      hasSendingOrder(data) ? LIST_POLL_INTERVAL_MS : false,
  });
